// @ts-nocheck
export const localeCodes =  [
  "en",
  "us",
  "nl",
  "fr",
  "de",
  "it",
  "id",
  "es",
  "pt",
  "br",
  "ja",
  "zh",
  "tr",
  "ko"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_GB_46json_5b87093a",
      load: () => import("#nuxt-i18n/5b87093a" /* webpackChunkName: "locale_en_GB_46json_5b87093a" */),
      cache: true
    }
  ],
  us: [
    {
      key: "locale_en_US_46json_7775058e",
      load: () => import("#nuxt-i18n/7775058e" /* webpackChunkName: "locale_en_US_46json_7775058e" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_NL_46json_0129c036",
      load: () => import("#nuxt-i18n/0129c036" /* webpackChunkName: "locale_nl_NL_46json_0129c036" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_FR_46json_8116594d",
      load: () => import("#nuxt-i18n/8116594d" /* webpackChunkName: "locale_fr_FR_46json_8116594d" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_DE_46json_309120e8",
      load: () => import("#nuxt-i18n/309120e8" /* webpackChunkName: "locale_de_DE_46json_309120e8" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_IT_46json_f044ecf9",
      load: () => import("#nuxt-i18n/f044ecf9" /* webpackChunkName: "locale_it_IT_46json_f044ecf9" */),
      cache: true
    }
  ],
  id: [
    {
      key: "locale_id_ID_46json_9c19ecf2",
      load: () => import("#nuxt-i18n/9c19ecf2" /* webpackChunkName: "locale_id_ID_46json_9c19ecf2" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_ES_46json_cf28c561",
      load: () => import("#nuxt-i18n/cf28c561" /* webpackChunkName: "locale_es_ES_46json_cf28c561" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_PT_46json_87d51bfd",
      load: () => import("#nuxt-i18n/87d51bfd" /* webpackChunkName: "locale_pt_PT_46json_87d51bfd" */),
      cache: true
    }
  ],
  br: [
    {
      key: "locale_pt_BR_46json_f2a247f8",
      load: () => import("#nuxt-i18n/f2a247f8" /* webpackChunkName: "locale_pt_BR_46json_f2a247f8" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_JP_46json_7b2ab865",
      load: () => import("#nuxt-i18n/7b2ab865" /* webpackChunkName: "locale_ja_JP_46json_7b2ab865" */),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_zh_CN_46json_6bb8f7c0",
      load: () => import("#nuxt-i18n/6bb8f7c0" /* webpackChunkName: "locale_zh_CN_46json_6bb8f7c0" */),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_tr_TR_46json_50351707",
      load: () => import("#nuxt-i18n/50351707" /* webpackChunkName: "locale_tr_TR_46json_50351707" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_KR_46json_c3ddf4c3",
      load: () => import("#nuxt-i18n/c3ddf4c3" /* webpackChunkName: "locale_ko_KR_46json_c3ddf4c3" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/6b2f2c53" /* webpackChunkName: "config_vueI18nConfig_46ts_6b2f2c53" */)
]
export const normalizedLocales = [
  {
    code: "en",
    language: "en-GB",
    abbreviation: "en",
    name: "English"
  },
  {
    code: "us",
    language: "en-US",
    abbreviation: "en",
    name: "English (US)"
  },
  {
    code: "nl",
    language: "nl-NL",
    abbreviation: "nl",
    name: "Nederlands"
  },
  {
    code: "fr",
    language: "fr-FR",
    abbreviation: "fr",
    name: "Français"
  },
  {
    code: "de",
    language: "de-DE",
    abbreviation: "de",
    name: "Deutsch"
  },
  {
    code: "it",
    language: "it-IT",
    abbreviation: "it",
    name: "Italiano"
  },
  {
    code: "id",
    language: "id-ID",
    abbreviation: "id",
    name: "Bahasa Indonesia"
  },
  {
    code: "es",
    language: "es-ES",
    abbreviation: "es",
    name: "Español"
  },
  {
    code: "pt",
    language: "pt-PT",
    abbreviation: "pt",
    name: "Português"
  },
  {
    code: "br",
    language: "pt-BR",
    abbreviation: "pt",
    name: "Português do Brasil"
  },
  {
    code: "ja",
    language: "ja-JP",
    abbreviation: "ja",
    name: "日本語"
  },
  {
    code: "zh",
    language: "zh-CN",
    abbreviation: "zh",
    name: "简体中文"
  },
  {
    code: "tr",
    language: "tr-TR",
    abbreviation: "tr",
    name: "Türkçe"
  },
  {
    code: "ko",
    language: "ko-KR",
    abbreviation: "ko",
    name: "한국어"
  }
]
/** client **/

/** client-end **/